
import Vue from 'vue'
import { DataSet } from '@/services/DataSet'
import DataTableCell from './DataTableCell.vue'

export default Vue.extend({
   name: 'DataTable',
   props: {
      data: Object as () => IDataSet,
      columns: Array as () => IDataTableColumn[],
      selectable: { type: Boolean, default: false },
      selectColumn: { type: String, default: 'IsSelected' },
   },
   data() {
      return {
         selectAll: false,
      }
   },
   computed: {
      displayColumns(): IDataTableColumn[] {
         return this.columns.filter(column => {
            if (column.type !== 'boolean-hide') {
               return true
            }
            const filter = this.data.filters.find(f => f.name === column.name)
            if (filter) {
               return filter.value !== 'true'
            }
            return true
         })
      },
   },
   methods: {
      showSort(columnName: string, direction: string) {
         return columnName === this.data.sortColumn && direction === this.data.sortDirection
      },

      sort(column: IDataTableColumn) {
         if (column.sortable !== false) {
            if (!!column.sortColumn) {
               this.data.sort(column.sortColumn)
            } else {
               this.data.sort(column.name)
            }
            this.$emit('change')
         }
      },

      select(column: any) {
         this.$emit('select', column)
      },
   },
   watch: {
      selectAll(value: boolean) {
         if (this.selectable) {
            this.data.items.forEach(item => {
               item[this.selectColumn] = value
            })
         }
      },
   },
   components: { DataTableCell },
})
